
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45kcm59t0_UaQBF7kkQiT7nEBu5VIANeRznJ8ePhPR9UMeta } from "/builds/lottocom/shop-frontend/frontend/pages/index.vue?macro=true";
import { default as loginWMb_459xQqff6hb2_45mgY8n_KponKLGTSJuDFx2SC45_hwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/login.vue?macro=true";
import { default as cool_45offpGcvFKG6zlf8MxjkeuAp_45ZoecIA8zu9KASOJgqfGBKoMeta } from "/builds/lottocom/shop-frontend/frontend/pages/cool-off.vue?macro=true";
import { default as nameW1By9QLDmbyIiU__FBlmGxnGE6TAoUQZNKS8x9UCqL4Meta } from "/builds/lottocom/shop-frontend/frontend/pages/register/name.vue?macro=true";
import { default as accountI3oMSrJJ4M_45OPk8HV_ToFKVS6CKbrYD51LYOo9SVBIkMeta } from "/builds/lottocom/shop-frontend/frontend/pages/register/account.vue?macro=true";
import { default as address1q_45GR91u8sHiRze_jMuv3Vx03oSwDLrWdznptmB2hMEMeta } from "/builds/lottocom/shop-frontend/frontend/pages/register/address.vue?macro=true";
import { default as personaldatan2xai2uz6YFdYPfGH_45KpioHXqsH74UTPy9n1bvkvOA4Meta } from "/builds/lottocom/shop-frontend/frontend/pages/register/personaldata.vue?macro=true";
import { default as registerKqOVXV3zmu9bxiyDVnPPN4N99A4wWD3D5ex9_dRxlBUMeta } from "/builds/lottocom/shop-frontend/frontend/pages/register.vue?macro=true";
import { default as two_45factorH1Qc_45oY2GqRLgQq62I1WrqWpWqpLV4i1ZceUZdrrwVUMeta } from "/builds/lottocom/shop-frontend/frontend/pages/two-factor.vue?macro=true";
import { default as indexE48CGFaIWNKuHfxoM5Wk_ZvJ1bpG36rdtGmqkpOPMkAMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/index.vue?macro=true";
import { default as successwi5OuO_457k98ZyHbP1wCmSgJYKVdRNvtQDRBkMjouuRAMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/success.vue?macro=true";
import { default as successlpzEpdHj_2r89922ivudST5qgA9T_45jsPks43714MQEgMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/avs/success.vue?macro=true";
import { default as indexI_oxVyDmMfnRcgiNVE6sO9IJJeGKjg1rjp6TDXABmZ8Meta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/upload/index.vue?macro=true";
import { default as errorCHMdTL9PLjDS2R57MJjWO5_45fULX3VRolWEBpm_457tH_458Meta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/error.vue?macro=true";
import { default as indexsLF9F1ElRfPUvtYwPnnSOKNKmmbURsiwPOUNmoHYY9MMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/index.vue?macro=true";
import { default as successoNzhvcRDvKVOBqh7Es4ibdENREHX_GWOs2_45MQTKglmsMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/upload/success.vue?macro=true";
import { default as pendingJTNMVF1XVRyCSfbjfUsX74gq4XwQS5hj5OI0OZmYqC4Meta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/pending.vue?macro=true";
import { default as successNjNPYCeN5OXYmzlgmr_W_e_45xU3_45Uw5hqHM2MJd4JcyYMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/success.vue?macro=true";
import { default as processinghf8X0xxCnyYWxf9DLmsjZzLpugkh7SNzsPAixaKlYSwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/processing.vue?macro=true";
import { default as indexzAouMjwkGt8eQoP_45qiH7p4AZmoPT55xmHQh7XemsJs8Meta } from "/builds/lottocom/shop-frontend/frontend/pages/verification/phone-number/index.vue?macro=true";
import { default as verificationTJSTPvG27xha3ZHuTy2gCthDpJ0FudyqpBEkRW7i8XQMeta } from "/builds/lottocom/shop-frontend/frontend/pages/verification.vue?macro=true";
import { default as indexYWDAPqsV75j92kJHlIOengKCazI1LOJoOczlWT9pqbwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/index.vue?macro=true";
import { default as indexC1vMq8FdivlE6GttB14RsHGrkZOsA4pr_457NNGJ4IUgEMeta } from "/builds/lottocom/shop-frontend/frontend/pages/results/index.vue?macro=true";
import { default as self_45excludedVOu1NyuzzapE2SDkhUshsmyGrO0RJ_45cSWGSRs_45G1ursMeta } from "/builds/lottocom/shop-frontend/frontend/pages/self-excluded.vue?macro=true";
import { default as indexDDnT6dO4kH5KLJADbGBVqgn5irta94PxlQQ83qEjpJYMeta } from "/builds/lottocom/shop-frontend/frontend/pages/service/index.vue?macro=true";
import { default as healthrTOnW_450_IkwsSWwzuPOWmTMGO5EGBmxl4oOU5BsCEgYMeta } from "/builds/lottocom/shop-frontend/frontend/pages/status/health.vue?macro=true";
import { default as indexKVOfaHfakIDBQhiomb2d1oZkNJp30XJ7n4BK_458Aq01gMeta } from "/builds/lottocom/shop-frontend/frontend/pages/checkout/index.vue?macro=true";
import { default as reset_45passwordwOjM7gftisHdsaoXxVi4JdfZF_17RCivftfE2z66_mAMeta } from "/builds/lottocom/shop-frontend/frontend/pages/reset-password.vue?macro=true";
import { default as _91slug_936U4XVAGNog3i5_45Khc1qUh2nAu49S68LLnrmbG2JvD7EMeta } from "/builds/lottocom/shop-frontend/frontend/pages/results/[slug].vue?macro=true";
import { default as age_45restrictionIxc6XtquRIZyl0ybahBS7_q2iHuG4UzRSHlr_45aAzBN0Meta } from "/builds/lottocom/shop-frontend/frontend/pages/age-restriction.vue?macro=true";
import { default as change_45passwordrIA_452FjDKyE7uwNqrKb_45dhT_hU_PDML5BZcAm5VupMwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/change-password.vue?macro=true";
import { default as forgot_45passwordte0cjTD4tG1D93fV4CeeGEA7jJZ3QIjBFxyWqgVkrawMeta } from "/builds/lottocom/shop-frontend/frontend/pages/forgot-password.vue?macro=true";
import { default as successh9hWjIHBXxJRQ549J6_xl_sL8GcD8ZQgvMjcY3eldWMMeta } from "/builds/lottocom/shop-frontend/frontend/pages/checkout/success.vue?macro=true";
import { default as indexYIb5EYmx5BmZLotTEpwS5w4yW60hGq6_457h1BJ5XZxnwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/[lotteryId]/index.vue?macro=true";
import { default as add_45fundsxWPC03ng3sZxY5aZsEuJ6ubX1UmBYWRc_bROS83XhP4Meta } from "/builds/lottocom/shop-frontend/frontend/pages/account/add-funds.vue?macro=true";
import { default as options1tpulGj9MCt_45a8gvitZoFWlK6ffZhOs776WHsPFzTPYMeta } from "/builds/lottocom/shop-frontend/frontend/pages/[lotteryId]/options.vue?macro=true";
import { default as checkdOQGraVrKjfKGqfqJ3PsYjni7F9f8Zn5Agxm4f6VYA0Meta } from "/builds/lottocom/shop-frontend/frontend/pages/account/payout/check.vue?macro=true";
import { default as indexd4ZZZsq4xSDWX7olPIgpWAaKSzPA6JGlxhi8SQBEa5wMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/payout/index.vue?macro=true";
import { default as transactionsJqg1oribKI5POowAvQI_45_45o3AY61wDlklzBdkedMJmmwMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/transactions.vue?macro=true";
import { default as successPo7DJuxDlbU0_bfM4jKfikgnXw4B5vkG4tGfIhg0b48Meta } from "/builds/lottocom/shop-frontend/frontend/pages/account/payout/success.vue?macro=true";
import { default as indexk3jNnz5PLny6evi4SvF0p81tPsHSTEZYbQBWeIUXMogMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/index.vue?macro=true";
import { default as payment_45methodsoG1CE4vhlruI9U_sX__qjbkJUxtkSaN76235jLTYU08Meta } from "/builds/lottocom/shop-frontend/frontend/pages/account/payment-methods.vue?macro=true";
import { default as indexUDVi_EZz8O4nonVqmaQXyJok_45Vqka4dAsSg_ZmXBmlMMeta } from "/builds/lottocom/shop-frontend/frontend/pages/scratchcard/[slug]/index.vue?macro=true";
import { default as securityPy40pz6uB333Peeoe8RPrfGeMvdWZXfHrNUMSTZpOGgMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/security.vue?macro=true";
import { default as _91id_93U7Qv8fyus5b4MGzFJqzKlutIn_0Zpw_45AzraaNByOpiMMeta } from "/builds/lottocom/shop-frontend/frontend/pages/my-orders/scratchcard/[id].vue?macro=true";
import { default as indexUfJ2uByrNyiKFOCaLfVL2R8Wu6PHBhHvwBlSGKg5IJcMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/personal-data/index.vue?macro=true";
import { default as _91id_93tcIDcdZPh_45ACb0_V71ehzTGytn1yry_1eBRzjG7ZRTcMeta } from "/builds/lottocom/shop-frontend/frontend/pages/my-orders/single-order/[id].vue?macro=true";
import { default as _91id_937z6l6r8e5EBmqzy5ugIwkheEqMN2ruNox_Z4Ql_45uZmkMeta } from "/builds/lottocom/shop-frontend/frontend/pages/my-orders/subscription/[id].vue?macro=true";
import { default as indexN5QzPQCknd7WMr69JXCVpGRGkNujX4YpCaDs2L9T0XcMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/limits/index.vue?macro=true";
import { default as close_45accountnvLZn9LWHPmA6UTHl2CghSS8GDdRxtPWnrIq8u4yOicMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/close-account.vue?macro=true";
import { default as _91slug_93MoTGQZXkOnlIKEQHZUlK5AVem8OiOOz35z3D4AUwTfoMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/limits/[slug].vue?macro=true";
import { default as self_45exclusionKVOqdgtbrU72sJhghxLgp0v2P70m2TCGhSiwQxf5BnkMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/self-exclusion.vue?macro=true";
import { default as marketing_45updatescDgaUsbM1Bvo0Z0rAEGIafvbp5ttfYR_45kAVzXhZCzE8Meta } from "/builds/lottocom/shop-frontend/frontend/pages/account/settings/marketing-updates.vue?macro=true";
import { default as edit_45phone_45numberu0nYC4qbrbFc87CilJYVEcAf_45GQTPtOaI1Td5LodoLAMeta } from "/builds/lottocom/shop-frontend/frontend/pages/account/personal-data/edit-phone-number.vue?macro=true";
import { default as component_45stubGyABec0eO2LKSao7epUc_45y_45bg6UjlPslI6_45xCs1rNFoMeta } from "/builds/lottocom/shop-frontend/frontend/node_modules/.pnpm/nuxt@3.16.2_patch_hash=5def9818cff2516e81c501b8f21bf66204ee2fca4271d1455d96717793a6460d_4d760d5dad13aef599d01862b72aa95b/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubGyABec0eO2LKSao7epUc_45y_45bg6UjlPslI6_45xCs1rNFo } from "/builds/lottocom/shop-frontend/frontend/node_modules/.pnpm/nuxt@3.16.2_patch_hash=5def9818cff2516e81c501b8f21bf66204ee2fca4271d1455d96717793a6460d_4d760d5dad13aef599d01862b72aa95b/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index_45kcm59t0_UaQBF7kkQiT7nEBu5VIANeRznJ8ePhPR9UMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginWMb_459xQqff6hb2_45mgY8n_KponKLGTSJuDFx2SC45_hwMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/login.vue")
  },
  {
    name: "cool-off",
    path: "/cool-off",
    meta: cool_45offpGcvFKG6zlf8MxjkeuAp_45ZoecIA8zu9KASOJgqfGBKoMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/cool-off.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerKqOVXV3zmu9bxiyDVnPPN4N99A4wWD3D5ex9_dRxlBUMeta || {},
    redirect: "/register/name",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/register.vue"),
    children: [
  {
    name: "register-name",
    path: "name",
    meta: nameW1By9QLDmbyIiU__FBlmGxnGE6TAoUQZNKS8x9UCqL4Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/register/name.vue")
  },
  {
    name: "register-account",
    path: "account",
    meta: accountI3oMSrJJ4M_45OPk8HV_ToFKVS6CKbrYD51LYOo9SVBIkMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/register/account.vue")
  },
  {
    name: "register-address",
    path: "address",
    meta: address1q_45GR91u8sHiRze_jMuv3Vx03oSwDLrWdznptmB2hMEMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/register/address.vue")
  },
  {
    name: "register-personaldata",
    path: "personaldata",
    meta: personaldatan2xai2uz6YFdYPfGH_45KpioHXqsH74UTPy9n1bvkvOA4Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/register/personaldata.vue")
  }
]
  },
  {
    name: "two-factor",
    path: "/two-factor",
    meta: two_45factorH1Qc_45oY2GqRLgQq62I1WrqWpWqpLV4i1ZceUZdrrwVUMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/two-factor.vue")
  },
  {
    name: verificationTJSTPvG27xha3ZHuTy2gCthDpJ0FudyqpBEkRW7i8XQMeta?.name,
    path: "/verification",
    meta: verificationTJSTPvG27xha3ZHuTy2gCthDpJ0FudyqpBEkRW7i8XQMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification.vue"),
    children: [
  {
    name: "verification",
    path: "",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/index.vue")
  },
  {
    name: "verification-success",
    path: "success",
    meta: successwi5OuO_457k98ZyHbP1wCmSgJYKVdRNvtQDRBkMjouuRAMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/success.vue")
  },
  {
    name: "verification-avs-success",
    path: "avs/success",
    meta: successlpzEpdHj_2r89922ivudST5qgA9T_45jsPks43714MQEgMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/avs/success.vue")
  },
  {
    name: "verification-upload",
    path: "upload",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/upload/index.vue")
  },
  {
    name: "verification-id-scan-error",
    path: "id-scan/error",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/error.vue")
  },
  {
    name: "verification-id-scan",
    path: "id-scan",
    meta: indexsLF9F1ElRfPUvtYwPnnSOKNKmmbURsiwPOUNmoHYY9MMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/index.vue")
  },
  {
    name: "verification-upload-success",
    path: "upload/success",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/upload/success.vue")
  },
  {
    name: "verification-id-scan-pending",
    path: "id-scan/pending",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/pending.vue")
  },
  {
    name: "verification-id-scan-success",
    path: "id-scan/success",
    meta: successNjNPYCeN5OXYmzlgmr_W_e_45xU3_45Uw5hqHM2MJd4JcyYMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/success.vue")
  },
  {
    name: "verification-id-scan-processing",
    path: "id-scan/processing",
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/id-scan/processing.vue")
  },
  {
    name: "verification-phone-number",
    path: "phone-number",
    meta: indexzAouMjwkGt8eQoP_45qiH7p4AZmoPT55xmHQh7XemsJs8Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/verification/phone-number/index.vue")
  }
]
  },
  {
    name: "account",
    path: "/account",
    meta: indexYWDAPqsV75j92kJHlIOengKCazI1LOJoOczlWT9pqbwMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/index.vue")
  },
  {
    name: "results",
    path: "/results",
    meta: indexC1vMq8FdivlE6GttB14RsHGrkZOsA4pr_457NNGJ4IUgEMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/results/index.vue")
  },
  {
    name: "self-excluded",
    path: "/self-excluded",
    meta: self_45excludedVOu1NyuzzapE2SDkhUshsmyGrO0RJ_45cSWGSRs_45G1ursMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/self-excluded.vue")
  },
  {
    name: "service",
    path: "/service",
    meta: indexDDnT6dO4kH5KLJADbGBVqgn5irta94PxlQQ83qEjpJYMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/service/index.vue")
  },
  {
    name: "status-health",
    path: "/status/health",
    meta: healthrTOnW_450_IkwsSWwzuPOWmTMGO5EGBmxl4oOU5BsCEgYMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/status/health.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: indexKVOfaHfakIDBQhiomb2d1oZkNJp30XJ7n4BK_458Aq01gMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/checkout/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordwOjM7gftisHdsaoXxVi4JdfZF_17RCivftfE2z66_mAMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/reset-password.vue")
  },
  {
    name: "results-slug",
    path: "/results/:slug()",
    meta: _91slug_936U4XVAGNog3i5_45Khc1qUh2nAu49S68LLnrmbG2JvD7EMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/results/[slug].vue")
  },
  {
    name: "age-restriction",
    path: "/age-restriction",
    meta: age_45restrictionIxc6XtquRIZyl0ybahBS7_q2iHuG4UzRSHlr_45aAzBN0Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/age-restriction.vue")
  },
  {
    name: "change-password",
    path: "/change-password",
    meta: change_45passwordrIA_452FjDKyE7uwNqrKb_45dhT_hU_PDML5BZcAm5VupMwMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/change-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordte0cjTD4tG1D93fV4CeeGEA7jJZ3QIjBFxyWqgVkrawMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/forgot-password.vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    meta: successh9hWjIHBXxJRQ549J6_xl_sL8GcD8ZQgvMjcY3eldWMMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/checkout/success.vue")
  },
  {
    name: "lotteryId",
    path: "/:lotteryId()",
    meta: indexYIb5EYmx5BmZLotTEpwS5w4yW60hGq6_457h1BJ5XZxnwMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/[lotteryId]/index.vue")
  },
  {
    name: "account-add-funds",
    path: "/account/add-funds",
    meta: add_45fundsxWPC03ng3sZxY5aZsEuJ6ubX1UmBYWRc_bROS83XhP4Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/add-funds.vue")
  },
  {
    name: "lotteryId-options",
    path: "/:lotteryId()/options",
    meta: options1tpulGj9MCt_45a8gvitZoFWlK6ffZhOs776WHsPFzTPYMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/[lotteryId]/options.vue")
  },
  {
    name: "account-payout-check",
    path: "/account/payout/check",
    meta: checkdOQGraVrKjfKGqfqJ3PsYjni7F9f8Zn5Agxm4f6VYA0Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/payout/check.vue")
  },
  {
    name: "account-payout",
    path: "/account/payout",
    meta: indexd4ZZZsq4xSDWX7olPIgpWAaKSzPA6JGlxhi8SQBEa5wMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/payout/index.vue")
  },
  {
    name: "account-transactions",
    path: "/account/transactions",
    meta: transactionsJqg1oribKI5POowAvQI_45_45o3AY61wDlklzBdkedMJmmwMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/transactions.vue")
  },
  {
    name: "account-payout-success",
    path: "/account/payout/success",
    meta: successPo7DJuxDlbU0_bfM4jKfikgnXw4B5vkG4tGfIhg0b48Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/payout/success.vue")
  },
  {
    name: "account-settings",
    path: "/account/settings",
    meta: indexk3jNnz5PLny6evi4SvF0p81tPsHSTEZYbQBWeIUXMogMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/index.vue")
  },
  {
    name: "account-payment-methods",
    path: "/account/payment-methods",
    meta: payment_45methodsoG1CE4vhlruI9U_sX__qjbkJUxtkSaN76235jLTYU08Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "scratchcard-slug",
    path: "/scratchcard/:slug()",
    meta: indexUDVi_EZz8O4nonVqmaQXyJok_45Vqka4dAsSg_ZmXBmlMMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/scratchcard/[slug]/index.vue")
  },
  {
    name: "account-settings-security",
    path: "/account/settings/security",
    meta: securityPy40pz6uB333Peeoe8RPrfGeMvdWZXfHrNUMSTZpOGgMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/security.vue")
  },
  {
    name: "my-orders-scratchcard-id",
    path: "/my-orders/scratchcard/:id()",
    meta: _91id_93U7Qv8fyus5b4MGzFJqzKlutIn_0Zpw_45AzraaNByOpiMMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/my-orders/scratchcard/[id].vue")
  },
  {
    name: "account-personal-data",
    path: "/account/personal-data",
    meta: indexUfJ2uByrNyiKFOCaLfVL2R8Wu6PHBhHvwBlSGKg5IJcMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/personal-data/index.vue")
  },
  {
    name: "my-orders-single-order-id",
    path: "/my-orders/single-order/:id()",
    meta: _91id_93tcIDcdZPh_45ACb0_V71ehzTGytn1yry_1eBRzjG7ZRTcMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/my-orders/single-order/[id].vue")
  },
  {
    name: "my-orders-subscription-id",
    path: "/my-orders/subscription/:id()",
    meta: _91id_937z6l6r8e5EBmqzy5ugIwkheEqMN2ruNox_Z4Ql_45uZmkMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/my-orders/subscription/[id].vue")
  },
  {
    name: "account-settings-limits",
    path: "/account/settings/limits",
    meta: indexN5QzPQCknd7WMr69JXCVpGRGkNujX4YpCaDs2L9T0XcMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/limits/index.vue")
  },
  {
    name: "account-settings-close-account",
    path: "/account/settings/close-account",
    meta: close_45accountnvLZn9LWHPmA6UTHl2CghSS8GDdRxtPWnrIq8u4yOicMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/close-account.vue")
  },
  {
    name: "account-settings-limits-slug",
    path: "/account/settings/limits/:slug()",
    meta: _91slug_93MoTGQZXkOnlIKEQHZUlK5AVem8OiOOz35z3D4AUwTfoMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/limits/[slug].vue")
  },
  {
    name: "account-settings-self-exclusion",
    path: "/account/settings/self-exclusion",
    meta: self_45exclusionKVOqdgtbrU72sJhghxLgp0v2P70m2TCGhSiwQxf5BnkMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/self-exclusion.vue")
  },
  {
    name: "account-settings-marketing-updates",
    path: "/account/settings/marketing-updates",
    meta: marketing_45updatescDgaUsbM1Bvo0Z0rAEGIafvbp5ttfYR_45kAVzXhZCzE8Meta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/settings/marketing-updates.vue")
  },
  {
    name: "account-personal-data-edit-phone-number",
    path: "/account/personal-data/edit-phone-number",
    meta: edit_45phone_45numberu0nYC4qbrbFc87CilJYVEcAf_45GQTPtOaI1Td5LodoLAMeta || {},
    component: () => import("/builds/lottocom/shop-frontend/frontend/pages/account/personal-data/edit-phone-number.vue")
  },
  {
    name: component_45stubGyABec0eO2LKSao7epUc_45y_45bg6UjlPslI6_45xCs1rNFoMeta?.name,
    path: "/responsible-gaming",
    component: component_45stubGyABec0eO2LKSao7epUc_45y_45bg6UjlPslI6_45xCs1rNFo
  }
]